exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".squarePaymentComponent-message-text{color:var(--text)}.squarePaymentComponent-message-icon{color:var(--text)}.squarePaymentComponent-buttonContainer{display:flex;flex-direction:row;justify-content:flex-end}.squarePaymentComponent-cancelButton{margin-right:15px}.squarePaymentComponent-input{background-color:var(--input-background-color);color:var(--input-text-color)}.squarePaymentComponent-input-placeholder{color:var(--input-text-color)}.squarePaymentComponent-input-container{border-color:var(--input-border-color)}.squarePaymentComponent-googlePayContainer{padding:0.25rem 0}\n", ""]);

// exports
